/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Ai_Tools_Trust_Secure_BodyInputs */

const en_directory_ai_tools_trust_secure_body = /** @type {(inputs: Directory_Ai_Tools_Trust_Secure_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Payments by Stripe. We never see your card.`)
};

const zh_directory_ai_tools_trust_secure_body = /** @type {(inputs: Directory_Ai_Tools_Trust_Secure_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`由 Stripe 处理付款，我们不会接触你的卡信息。`)
};

/**
* | output |
* | --- |
* | "Payments by Stripe. We never see your card." |
*
* @param {Directory_Ai_Tools_Trust_Secure_BodyInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_ai_tools_trust_secure_body = /** @type {((inputs?: Directory_Ai_Tools_Trust_Secure_BodyInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Ai_Tools_Trust_Secure_BodyInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_ai_tools_trust_secure_body(inputs)
	return zh_directory_ai_tools_trust_secure_body(inputs)
});
export { directory_ai_tools_trust_secure_body as "directory.ai_tools.trust.secure_body" }